"use client";

import { useEffect, useState } from "react";
import ENDPOINTS, { TargetCategoryNameType } from "../../../constants/apis/endpoints";
import microCmsGetAuth from "../../../constants/apis/microCmsGetApiKey";
import { microCmsAuthType } from "../../../types/microCmsAuthType";
import { useSearchParams } from "next/navigation";
import plt_getOffset from "../../../libs/plt_getOffset";
import Pagination from "../../../components/molecules/Pagination/Pagination";
import useFetchContentsListByCategory from "../../../hooks/useFetchContentsListByCategory.hooks";
import ArticleItems from "../../../components/organisms/ArticleItems/ArticleItems";

const ArchiveNewsList = (props: TargetCategoryNameType) => {
  const {targetEndpointId, targetCategoryName} = props;
  const endpoints = ENDPOINTS;
  const microCMSAuth: microCmsAuthType = microCmsGetAuth;

  const searchParams = useSearchParams();
  // パラメータなしは1ページとして扱う
  const currentPageNum = searchParams.get("page") || "1";

  // クエリパラメータのpage番号を元にoffsetを取得する
  const offset = plt_getOffset(Number(currentPageNum), endpoints["news"].POSTS_PER_PAGE);
  const postsPerPage = endpoints[targetEndpointId].POSTS_PER_PAGE;

  const [response, setResponse] = useState<any>();
  const [totalCount, setTotalCount] = useState(0);
  // 不正値のとき
  const [isNotFound, setIsNotFound] = useState(false);

  useEffect(() => {
    const FetchData = async () => {
      // クエリ
      const q_plt_queries = {"endpointId": endpoints[targetEndpointId].ID, category: targetCategoryName || "", "limit": postsPerPage}
      // API GET
      const contentList = await useFetchContentsListByCategory(
        microCMSAuth, q_plt_queries, offset);
      setResponse(contentList);
      setTotalCount(contentList.responseBody.totalCount);

      // page=1, pageパラメータなし
      if(Number(currentPageNum) != 1 && currentPageNum == "" && contentList.responseBody.contents.length <= 0) {
        setIsNotFound(true);
      }

      // page=1のときはパラメータなしに飛ばしたい。
      // currentPageNum とは別の値が必要

    }
    FetchData();
  }, [currentPageNum])

  if (isNotFound) {
    window.location.replace(`/${targetEndpointId}/`);
  }

  return (
    <>
      {/* debug code */}
      {/* {JSON.stringify(response?.responseBody)} */}
      {response?.responseBody.contents ? (
        <>
          <ArticleItems
            articleItems={response?.responseBody.contents}
            endpoint={targetEndpointId}
          />

          {(postsPerPage < totalCount) ? (
            <Pagination
              originalActive={offset}
              totalCount={totalCount}
              contentsName={endpoints[targetEndpointId].ID}
              postsPerPage={postsPerPage}
              pageNumber={currentPageNum}
            />
          ) : null}
        </>
      ) : (null)}
    </>
  )
}

export default ArchiveNewsList;